import { Component, ChangeDetectionStrategy, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import "@maersk-global/mds-components-core-top-bar";

@Component({
  selector: "app-layout",
  imports: [RouterOutlet],
  templateUrl: "./empty-layout.html",
  styleUrls: ["./empty-layout.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmptyLayoutComponent {}
